import LayoutSettings from '@/components/LayoutSetting/LayoutSettings';
import { deliverySettingSelector, handleSaveDeliverySettings } from '@/redux/slice/delivery.slice';
import { handleSetErrorFields } from '@/redux/slice/error.slice';
import { handleSetSaveBar } from '@/redux/slice/savebar.slice';
import { Checkbox } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const DeliveryZoneStatus = () => {
  const { t } = useTranslation('deliverySettings');

  const deliverySettings = useSelector(deliverySettingSelector);
  const dispatch = useDispatch();

  const handleCheckDeliveryZoneStatus = (checked: boolean) => {
    dispatch(
      handleSetSaveBar({
        isShowSaveBar: true,
        isCheckSave: false,
      }),
    );

    dispatch(handleSaveDeliverySettings({ isActive: checked }));

    if (deliverySettings.postalCodeValidation.exactMatchPostalCodes.length === 0) {
      dispatch(
        handleSetErrorFields({
          errorFields: {
            errorPostalCode: false,
            errorDupPostalCode: false,
          },
        }),
      );
    }
  };

  return (
    <LayoutSettings
      title={t('sections.settingsStatus.title')}
      helpText={t('sections.settingsStatus.helpText')}
      children={
        <Checkbox
          label={t('sections.settingsStatus.turnOn')}
          checked={deliverySettings.isActive}
          onChange={handleCheckDeliveryZoneStatus}
        />
      }
    />
  );
};

export default DeliveryZoneStatus;
